import { render, staticRenderFns } from "./DetailsCardDialog.vue?vue&type=template&id=759bf78a&scoped=true"
import script from "./DetailsCardDialog.vue?vue&type=script&lang=js"
export * from "./DetailsCardDialog.vue?vue&type=script&lang=js"
import style0 from "./DetailsCardDialog.vue?vue&type=style&index=0&id=759bf78a&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "759bf78a",
  null
  
)

export default component.exports